import { Injectable } from '@angular/core';
import { AgreementSignService } from './AgreementSignService';
import { ToastService, Severity } from '../../../../shared/components/toast/toast.service';

export interface SignAgreementParams {
  referenceCode: string;
  signedByRole: 'SELLER' | 'BUYER';
  signedByPartyId?: string;
  signedByName?: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

@Injectable({
  providedIn: 'root'
})
export class AgreementSigningHandlerService {

  private readonly SIGN_TOOL_URL = '/assets/tools/HomeCastaSetupTools.zip';
  private readonly SIGN_TOOL_32bit_URL = '/assets/tools/HomeCastaSetupTools32bit.zip';

  constructor(
    private agreementSignService: AgreementSignService,
    private toastService: ToastService
  ) {}

  async signAgreement(params: SignAgreementParams): Promise<boolean> {
    try {
      const pullResult = await this.agreementSignService.pullSigningData(params.referenceCode).toPromise();

      if (!pullResult || !pullResult.base64FileData) {
        throw new Error('Không thể tải dữ liệu PDF để ký');
      }

      let filteredSigningBlocks = pullResult.signatureLocationList || [];

      if (params.signedByRole === 'SELLER') {
        filteredSigningBlocks = filteredSigningBlocks.filter((block: any) =>
          block.roleTypeId === 'SellerSignedExec'
        );
      } else if (params.signedByRole === 'BUYER') {
        filteredSigningBlocks = filteredSigningBlocks.filter((block: any) =>
          block.roleTypeId === 'BuyerSignedExec'
        );
      }

      const signResult = await this.agreementSignService.signWithTool({
        referenceNumber: params.referenceCode,
        baseUrl: `${window.location.origin}/api`,
        signingBlocks: filteredSigningBlocks,
        fileName: pullResult.fileName,
        pdfBase64: pullResult.base64FileData,
        signedBy: params.signedByRole
      });

      if (signResult?.success && signResult?.data?.signedFilesBase64?.length > 0) {
        const signedPdfBase64 = signResult.data.signedFilesBase64[0];
        const pushData: any = {
          referenceCode: params.referenceCode,
          base64FileData: signedPdfBase64,
          signedByRole: params.signedByRole
        };

        if (params.signedByRole === 'SELLER' && params.signedByPartyId) {
          pushData.signedByPartyId = params.signedByPartyId;
        } else if (params.signedByRole === 'BUYER' && params.signedByName) {
          pushData.signedByName = params.signedByName;
        }

        await this.agreementSignService.pushSignedData(pushData).toPromise();

        this.toastService.setMessage({
          severity: Severity.SUCCESS,
          detail: 'Ký biên bản thành công!'
        });

        if (params.onSuccess) {
          params.onSuccess();
        }

        return true;
      } else {
        throw new Error('Ký số thất bại');
      }

    } catch (error: any) {
      console.error('Lỗi ký biên bản:', error);

      this.toastService.setMessage({
        severity: Severity.ERROR,
        detail: error?.message || 'Không thể ký biên bản'
      });

      if (params.onError) {
        params.onError(error);
      }

      return false;
    }
  }

  /**
   * Tải tool ký điện tử
   */
  downloadSignTool(): void {
    window.open(this.SIGN_TOOL_URL, '_blank');
  }
  downloadSignTool32bit(): void {
    window.open(this.SIGN_TOOL_32bit_URL, '_blank');
  }
}

